import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, exhaustMap, map, mergeMap, switchMap, tap} from 'rxjs/operators';
import * as UserActions from '../_actions/user.actions';
import {DataService} from 'shared/_services/data.service';
import {LOGGED_USER_STORE_KEY} from 'shared/magic';
import {LoggedUser} from 'app/_interfaces/logged-user';
import {Version} from 'app/_interfaces/version.interface';
import {EMPTY, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {EditModeService} from 'shared/_services/edit-mode.service';

@Injectable()
export class UserEffects {
	initUser$ = createEffect(() => this.actions$.pipe(
		ofType(UserActions.initUser),
		mergeMap(() => this.data.getLocal(LOGGED_USER_STORE_KEY).pipe(
			map((user: LoggedUser) => user ?
				UserActions.login({user}) : UserActions.localNotPresent()),
			catchError(() => of(UserActions.localNotPresent))
		))
	));

	saveLoginUser$ = createEffect(() => this.actions$.pipe(
		ofType(UserActions.login),
		tap(({user}: {user: LoggedUser}) => this.data.setInstant(LOGGED_USER_STORE_KEY, user))
	), {dispatch: false});

	checkVersion$ = createEffect(() => this.actions$.pipe(
		ofType(UserActions.checkVersion),
		mergeMap(({appVersion}) => this.http.get<Version>('/assets/version.json').pipe(
			map((currentVersion: Version) => {
				if (appVersion.raw === currentVersion.raw) return UserActions.latestVersion();
				return UserActions.oldVersion();
			}),
			catchError(() => EMPTY)
		))
	));

	logout$ = createEffect(() => this.actions$.pipe(
		ofType(UserActions.logout),
		exhaustMap(() => {
			return this.editModeService.disable().pipe(
				switchMap(() => this.data.post('api/users/revoke-token', {}).pipe(
					tap(() => {
						this.data.removeItem(LOGGED_USER_STORE_KEY);
					}),
					map(() => UserActions.localNotPresent()),
					catchError(() => of(UserActions.localNotPresent()))
				)),
				catchError(() => of(UserActions.localNotPresent()))
			);
		})
	));

	constructor(
		private actions$: Actions,
		private data: DataService,
		private http: HttpClient,
		private editModeService: EditModeService
	) {}
}
